/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Label, Text, Pressable, CheckIconButton } from '@components/atoms'
import { FullModalLayout } from '@components/molecules'
import { AdminEditMenu } from '@components/systems'

import { grey, deepPurple } from '@mui/material/colors'
import { useAppDispatch, adminActions } from '@redux/index'

const CreateMenuPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// state
	const [menuType, setMenuType] = React.useState<'dir' | 'object'>('dir')

	const onCloseClick = React.useCallback(() => {
		reduxDispatch(adminActions.EDIT_MENU_MODE('update'))
	}, [])

	const onTypeClick = React.useCallback((aType: 'dir' | 'object') => {
		setMenuType(aType)
		reduxDispatch(adminActions.EDIT_MENU_MODE(`create-${aType}`))
		reduxDispatch(adminActions.TRIGGER_CREATE_MENU_PAGE(true))
	}, [])

	return (
		<View css={style}>
			<FullModalLayout
				title="새 메뉴 추가"
				onCloseClick={onCloseClick}
				titleStyle={{ marginBottom: '1rem' }}
			>
				<View className="menuTypeSelectOuter">
					<Label className="menuTypeLabel">타입 선택</Label>

					<View className="menuTypeSelectView">
						<View className="menuTypeView">
							<CheckIconButton
								className="checkIconButton"
								activeColor={deepPurple['A400']}
								checked={menuType === 'dir'}
							/>
							<Pressable
								className={`menuTypeButton ${menuType === 'dir' ? 'selected' : ''}`}
								onClick={() => onTypeClick('dir')}
							>
								<Text className="menuTypeTitle">폴더</Text>
							</Pressable>
						</View>

						<View className="menuTypeView">
							<CheckIconButton
								className="checkIconButton"
								activeColor={deepPurple['A400']}
								checked={menuType === 'object'}
							/>
							<Pressable
								className={`menuTypeButton ${menuType === 'object' ? 'selected' : ''}`}
								onClick={() => onTypeClick('object')}
							>
								<Text className="menuTypeTitle">오브젝트</Text>
							</Pressable>
						</View>
					</View>
				</View>

				<AdminEditMenu />
			</FullModalLayout>
		</View>
	)
}

export default CreateMenuPage

const style = css({
	'.menuTypeSelectOuter': {
		marginBottom: '1rem',

		'.menuTypeLabel': {
			paddingLeft: '0.4rem',
			textAlign: 'left',
		},

		'.menuTypeSelectView': {
			display: 'flex',

			'.menuTypeView': {
				position: 'relative',
				width: '50%',
				padding: '0.2rem',

				'.checkIconButton': {
					position: 'absolute',
					top: 0,
					bottom: 0,
					left: '0.5rem',
					margin: 'auto',
				},

				'.menuTypeButton': {
					width: '100%',
					height: '3rem',
					background: '#FFF',
					border: '1px solid',
					borderColor: grey[300],
					borderRadius: '5px',

					'&.selected': {
						borderColor: deepPurple['A400'],
						'.menuTypeTitle': {
							color: deepPurple['A400'],
						},
					},

					'.menuTypeTitle': {
						color: grey[700],
					},
				},
			},
		},
	},
})
